import { useCallback } from "react";
import { useUpdatePatientDetailsCache } from "./useUpdatePatientDetailsCache";
import { useUpdateCardCollectionCache } from "@/features/card-collection/hooks/useUpdateCardCollectionCache";
import { PaymentCard } from "@/features/payment/types";

interface CardStatePatch {
  cardOnFile?: PaymentCard;
  cardCapture?: {
    sessionId: string;
    state: "sent";
  };
}

export function useUpdatePatientCardCache(patientId: string) {
  const updatePatientDetails = useUpdatePatientDetailsCache(patientId);
  const updateCardCollection = useUpdateCardCollectionCache(patientId);

  return useCallback(
    (patch: CardStatePatch) => {
      updatePatientDetails(patch);
      updateCardCollection({ patient: patch });
    },
    [updatePatientDetails, updateCardCollection],
  );
}
